module.exports = __webpack_public_path__ + "img/total-app-users.52973a2.png";